import { IconElementsProps } from "../icon-elements-props.type";
import { iconSizes } from "../icon-sizes";

export function Certificates(props: IconElementsProps) {
  const {
    className,
    primaryColor = "#00083C",
    width,
    height,
    size = "S",
  } = props;

  return (
    <svg
      className={className}
      style={{
        minWidth: width || iconSizes[size],
        minHeight: width || iconSizes[size],
      }}
      width={width || iconSizes[size]}
      height={height || iconSizes[size]}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7778 19.5556H17.4444C17.857 19.5556 18.2527 19.3917 18.5444 19.0999C18.8361 18.8082 19 18.4126 19 18V7.88889L15.1111 4H8.1111C7.69854 4 7.30288 4.16389 7.01115 4.45561C6.71943 4.74733 6.55554 5.143 6.55554 5.55556V7.88889"
        stroke={primaryColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3334 4V7.11111C14.3334 7.52367 14.4973 7.91933 14.789 8.21106C15.0807 8.50278 15.4764 8.66667 15.8889 8.66667H19"
        stroke={primaryColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33333 15.6667C7.63975 15.6667 7.94317 15.6063 8.22626 15.4891C8.50935 15.3718 8.76658 15.1999 8.98325 14.9832C9.19992 14.7666 9.37179 14.5094 9.48905 14.2263C9.60631 13.9432 9.66667 13.6398 9.66667 13.3333C9.66667 13.0269 9.60631 12.7235 9.48905 12.4404C9.37179 12.1573 9.19992 11.9001 8.98325 11.6834C8.76658 11.4667 8.50935 11.2949 8.22626 11.1776C7.94317 11.0604 7.63975 11 7.33333 11C6.7145 11 6.121 11.2458 5.68342 11.6834C5.24583 12.121 5 12.7145 5 13.3333C5 13.9522 5.24583 14.5457 5.68342 14.9832C6.121 15.4208 6.7145 15.6667 7.33333 15.6667Z"
        stroke={primaryColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.88889 15.2778L9.66667 19.5556L7.33333 18.7778L5 19.5556L5.77778 15.2778"
        stroke={primaryColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
